import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addCart, delCart } from "../redux/action";
import { Link } from "react-router-dom";
import configData from "../config.json";
import axios from "axios";
import "../styles/product.css"; 

const ShowCart = () => {
  const cart = useSelector((state) => state.handleCart);
  const dispatch = useDispatch();

  const [branchInfo, setBranchInfo] = useState([]);
  const [loadingPolicy, setLoadingPolicy] = useState(true);

  // 🔹 Fetch Branch Info
  useEffect(() => {
    const fetchBranch = async () => {
      try {
        if (cart.length === 0) return;

        const branchId = cart[0]?.BranchId;

        const res = await axios.get(
          `${configData.SERVER_URL}/enterprises/${branchId}`
        );

        setBranchInfo(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingPolicy(false);
      }
    };

    fetchBranch();
  }, [cart]);

  // 🔹 Cart Actions
  const addItem = (item) => dispatch(addCart(item));
  const removeItem = (item) => dispatch(delCart(item));

  // 🔹 Calculations
  const subtotal = cart.reduce(
    (acc, item) => acc + item.ProductPrice * item.qty,
    0
  );

  const totalItems = cart.reduce((acc, item) => acc + item.qty, 0);

  const shipping = 0;

  // 🔹 Empty Cart
  if (cart.length === 0) {
    return (
      <div className="container py-5 text-center">
        <h3 className="mb-3">🛒 Your Cart is Empty</h3>
        <p className="text-muted">Looks like you haven’t added anything yet</p>
        <Link to="/" className="btn btn-outline-dark mt-3">
          Continue Shopping
        </Link>
      </div>
    );
  }

  return (
    <div className="container py-4">

      {/* Title */}
      <h3 className="mb-4 text-success fw-bold text-center">
        Shopping Cart
      </h3>

      <div className="row g-4">

        {/* Cart Items */}
        <div className="col-md-8">
          <div className="card shadow-sm border-0">

            <div className="card-header bg-light">
              <strong>Items ({totalItems})</strong>
            </div>

            <div className="card-body">
              {cart.map((item) => (
                <div key={item.ProductID} className="row align-items-center mb-4">

                  {/* Image */}
                  <div className="col-3 text-center">
                    <img
                      src={`${configData.IMAGE_URL}/products/${item.Image}`}
                      alt={item.ProductName}
                      className="img-fluid rounded"
                      style={{ maxHeight: "80px", objectFit: "contain" }}
                    />
                  </div>

                  {/* Info */}
                  <div className="col-5">
                    <h6 className="mb-1">{item.ProductName}</h6>
                    <small className="text-muted">{item.proSize}</small>
                  </div>

                  {/* Quantity */}
                  <div className="col-4 text-center">
                    <div className="d-flex justify-content-center align-items-center gap-2">

                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => removeItem(item)}
                      >
                        −
                      </button>

                      <span>{item.qty}</span>

                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => addItem(item)}
                      >
                        +
                      </button>
                    </div>

                    <div className="mt-2 fw-semibold text-success">
                      ৳ {(item.qty * item.ProductPrice).toLocaleString()}
                    </div>
                  </div>

                  <hr className="mt-3" />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Summary */}
        <div className="col-md-4">

          {/* Order Summary */}
          <div className="card shadow-sm border-0 mb-3">
            <div className="card-header bg-light">
              <strong>Order Summary</strong>
            </div>

            <div className="card-body">
              <div className="d-flex justify-content-between">
                <span>Items ({totalItems})</span>
                <span>৳ {subtotal.toLocaleString()}</span>
              </div>

              <div className="d-flex justify-content-between mt-2">
                <span>Shipping</span>
                <span>৳ {shipping}</span>
              </div>

              <hr />

              <div className="d-flex justify-content-between fw-bold">
                <span>Total</span>
                <span className="text-success">
                  ৳ {(subtotal + shipping).toLocaleString()}
                </span>
              </div>

              <Link
                to="/checkout"
                className="btn btn-success w-100 mt-3"
              >
                Proceed to Checkout
              </Link>
            </div>
          </div>

          {/* Transport Policy */}
          <div className="card shadow-sm border-0">
            <div className="card-header bg-light">
              <strong>Transport Policy</strong>
            </div>

            <div className="card-body">
              {loadingPolicy ? (
                <p>Loading...</p>
              ) : branchInfo?.length > 0 ? (
                branchInfo.map((branch) => (
                  <ul key={branch.id} className="small text-danger">
                    {branch.transportPolicy
                      ?.split(";")
                      .map((line, i) => (
                        <li key={i}>{line}</li>
                      ))}
                  </ul>
                ))
              ) : (
                <p className="text-muted">No policy available</p>
              )}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ShowCart;